export default __webpack_public_path__ + "static/media/img-senior-adult.05451ff2.svg";